import React from 'react';
import styles from './regions.module.css';
import { InferGetServerSidePropsType } from 'next';
import Link from 'next/link';
import getConfig from 'next/config';
import Head from 'next/head';
import { useRouter } from 'next/router';

const { publicRuntimeConfig } = getConfig();

export async function getServerSideProps() {
  const res = await fetch(`${publicRuntimeConfig.INTERNAL_API_URL}/regions`);
  const resp = await res.json();

  return { props: { resp } };
}

type Data = {
  id: string;
  type: string;
  attributes: {
    name: string;
    code: number;
    genitive_name: null | string;
  };
}[];

const Regions = ({ resp }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  const { data }: { data: Data } = resp;
  const router = useRouter();
  const canonicalUrl = `${publicRuntimeConfig.BASE_URL}${router.asPath}`;
  return (
    <>
      <Head>
        <title>Список регионов и городов Каталога школ Учи.ру</title>
        <link rel="canonical" href={canonicalUrl} />
      </Head>
      <div className={styles.wrapper}>
        {data.map((e) => (
          <React.Fragment key={e.id}>
            <Link href={`regions/${e.attributes.code}`}>
              <a className={styles.region_link}> {e.attributes.name}</a>
            </Link>
            <Link href={`regions/${e.attributes.code}/cities`}>
              <a className={styles.cities_link}>
                Список городов {e.attributes.genitive_name || e.attributes.name}
              </a>
            </Link>
          </React.Fragment>
        ))}
      </div>
    </>
  );
};

export default Regions;
